<app-generic-sidebar
  [initialCollapsed]="isCollapsed()"
  [sections]="filteredMenuSections()"
  [baseRoutePath]="'assets/' + currentAsset()?.id"
  [isDisabledFn]="isUnderConstruction"
  (isCollapsedChange)="updateCollapsedState($event)"
  (homeNavigate)="navigateHome()">
  <ng-template sidebarHeader>
    <div class="flex flex-col justify-between transition-opacity duration-50">
      @if (currentAsset()?.name; as assetName) {
        <h1 class="font-bold text-lg">{{ assetName }}</h1>
      }
      <div class="flex items-center">
        <ces-favorite-button [isFavorite]="!!currentAsset()?.isFavorite" (favoriteToggle)="toggleFavorite()" />
        <p-tag styleClass="ml-2" [rounded]="true">{{ currentAssetGroup()?.name }}</p-tag>
      </div>
    </div>
  </ng-template>

  <ng-template sidebarFooter>
    @if (documentationUrl) {
      <ces-button-secondary
        (onClick)="openDocumentation()"
        icon="open_in_new"
        iconPosition="right"
        size="small"
        [label]="'sidebar.documents' | transloco" />
    }
    <p class="mt-2 flex flex-col items-center" style="font-size: var(--text-sm); color: var(--text-disabled)">
      version {{ appVersion() }}
    </p>
  </ng-template>
</app-generic-sidebar>
